// Used in profile.module.ts

// Angular
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

// RXJS/Store
import { Store, select } from "@ngrx/store";
import * as fromStore from "#login/store";
import { Observable } from "rxjs";

// Services/Types/Helpers
import { PPUser as User } from "cli-types";

@Component({
    selector: "profile-card",
    templateUrl: "./profile-card.component.html",
    styleUrls: [
        "./profile-card.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class ProfileCardComponent implements OnInit {
    profileData$?: Observable<User>;

    constructor(
        public store: Store<fromStore.UserState>,
        private titleService: Title
    ) {}

    ngOnInit() {
        this.titleService.setTitle("Carnegie Learning - Edit Profile");
        this.profileData$ = this.store.pipe(select(fromStore.getUserProfile));
    }
}
